import styled from "styled-components";

const TitleMain = styled.div`
  width: 100%;
  margin: ${({ marginBottom }) => (marginBottom ? `0 auto ${marginBottom}` : "0 auto 30px")};
  display: flex;
  justify-content: center;
  @media (max-width: 910px) {
    margin: 0 auto 10px;
    width: ${({ width910 }) => (width910 ? width910 : "85%")};
  }
  @media (max-width: 650px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
const TitleContainer = styled.div`
  width: 100%;
  max-width: 860px;
  border-bottom: 3px solid #808080;
  display: flex;
`;
const Title = styled.p`
  font-size: 18px;
  font-weight: bold;
  color: #808080;
  @media (max-width: 650px) {
    font-size: 14px;
  }
`;
const Subtitle = styled.p`
  margin-left: 5px;
  font-size: 18px;
  color: #808080;
  @media (max-width: 650px) {
    font-size: 14px;
  }
`;

const TitleSection = ({ title, subtitle, marginBottom, width910 }) => (
  <TitleMain marginBottom={marginBottom} width910={width910}>
    <TitleContainer>
      <Title>{title}</Title>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </TitleContainer>
  </TitleMain>
);

export default TitleSection;
